// Secure sanitization function for dynamic column names

export default (input) => {
  if (!input || typeof input !== 'string') return '';
  
  // Convert to lowercase and replace spaces with underscores
  let sanitized = input.toLowerCase().replace(/\s+/g, '_');
  
  // Remove all characters except alphanumeric and underscores
  sanitized = sanitized.replace(/[^a-z0-9_]/g, '');
  
  // Remove leading/trailing underscores and limit length
  sanitized = sanitized.replace(/^_+|_+$/g, '').substring(0, 50);
  
  // Ensure it doesn't start with a number
  if (/^[0-9]/.test(sanitized)) {
    sanitized = 'col_' + sanitized;
  }
  
  return sanitized || 'unknown';
};  